import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as drawerActions from '../../../../actions/drawerActions';
import * as messageAlert from '../../../../actions/messageAlertAction';
import * as classroomActions from '../../../../actions/classroom/classroomActions';
import { I18n } from 'react-redux-i18n-lite';

import * as classroomApi from '../../../../services/api/classroomApi';
import * as revealActions from '../../../../actions/revealActions';
import * as taskActions from '../../../../actions/taskActions';
import MultipleSelectionPanel from '../../../drawer-contents/MultipleSelectionPanel';
import { DrawerCommonPanelCustom } from './AddUserComponents';
import * as bookActions from '../../../../actions/bookActions';
import * as groupApi from '../../../../services/api/groupApi';
import * as bookApi from '../../../../services/api/bookApi';
import { fiterEditTaskUsers } from '../../../../utils/AssignContentPanelUtils';
import CircularProgress from '@material-ui/core/CircularProgress';

class AddUserToTask extends Component {
  constructor(props) {
    super(props);
    this.count = 1;
  }

  state = {
    users: [],
    initialSelection: [],
    currentSelection: [],
    currentUnselected: [],
    hasMoreItems: true,
    bookData: {},
    filteredUsers: false,
    showLoader: !!this.props.task.bookId
  };

  componentDidMount() {
    /*    const task = {
             ...this.props.task,
             content: this.state.bookData.auOrBlock,
             bookData: this.state.bookData
           };*/
    if (this.props.task.bookId && this.props.task.activities && this.props.task.activities.length) {
      const allGroups = this.props.allGroups;
      bookApi.getBook(this.props.idClassroom, this.props.task.bookId).then(res => {
        this.setState({
          bookData: res.data
        });
        classroomApi.getStudents(this.props.idClassroom).then(res => {
          const { users } = this.state;
          const usersActiv = fiterEditTaskUsers(
            {
              ...this.props.task,
              content: this.state.bookData.auOrBlock,
              bookData: this.state.bookData,
              groups: allGroups
            },
            res.data
          );
          if (usersActiv.groups.length) {
            const existAlll = usersActiv.groups.find(groupId => groupId === 0);
            if (existAlll === 0) {
              this.setState({ group_all: res.data });
            } else {
              usersActiv.groups.map(group => {
                groupApi.getStudents(group).then(res => {
                  const groupName = 'group_' + group;
                  this.setState({ [groupName]: users.concat(res.data) });
                });
              });
            }
          }
          this.setState({
            // users: res.data,
            avaliableUsersAndGroups: usersActiv,
            hasMoreItems: false
          });
        });
      });
    } else {
      classroomApi.getStudents(this.props.idClassroom).then(res => {
        this.setState({ group_all: res.data });
      });
    }
    classroomApi.getStudentsFromTask(this.props.idClassroom, this.props.task._id).then(res => {
      this.setState({
        currentSelection: res.data,
        initialSelection: res.data
      });
    });
  }

  filterAvaliableStudents = () => {
    Array.prototype.unique = (function(a) {
      return function() {
        return this.filter(a);
      };
    })(function(a, b, c) {
      return c.indexOf(a, b + 1) < 0;
    });
    const objKeysGroups = Object.keys(this.state);
    const filterStudents = [];
    objKeysGroups.map(key => {
      if (key.indexOf('group_') > -1 && this.state[key]) {
        this.state[key].map(std => filterStudents.push(std));
      }
    });
    const studentTask = this.state.avaliableUsersAndGroups ? this.state.avaliableUsersAndGroups.studentsTask : [];
    return filterStudents.length > 0 ? filterStudents.unique() : studentTask;
  };

  handlePrimaryButtonClick = async () => {
    const { task, revealActions } = this.props;
    const { currentSelection, currentUnselected } = this.state;

    const usersWithFiles = [];

    currentUnselected.map(user => {
      if (task.studentAttempts[user._id] && task.studentAttempts[user._id].responses.length) {
        usersWithFiles.push(user);
      }
    });

    if (usersWithFiles.length) {
      revealActions.openStudentsWithFilesReveal(true, usersWithFiles);
    } else {
      this.submitStudents(currentSelection);
    }
  };

  handleOnUserClick = user => {
    const { task, messageAlert } = this.props;
    const { currentSelection, currentUnselected } = this.state;

    const isSelected = currentSelection.filter(u => user._id === u._id).length > 0;

    if (isSelected) {
      if (task.studentAttempts[user._id] && task.studentAttempts[user._id].evaluation) {
        messageAlert.info(I18n.t('addUserToTaskReveal.studentEvaluatedAlert'));
      } else {
        this.setState({
          currentSelection: currentSelection.filter(u => user._id !== u._id),
          currentUnselected: [...currentUnselected, user]
        });
      }
    } else {
      this.setState({
        currentSelection: [...currentSelection, user],
        currentUnselected: currentUnselected.filter(u => user._id !== u._id)
      });
    }
  };

  tryIfChangedList = () => {
    const { currentSelection, initialSelection } = this.state;
    let changed = false;
    if (currentSelection.length !== initialSelection.length) {
      return true;
    }
    currentSelection.map(current => {
      const user = initialSelection.find(initial => initial._id === current._id);
      if (user === undefined) {
        changed = true;
      }
    });
    return changed;
  };

  submitStudents = currentSelection => {
    const { task, taskActions, drawerActions, revealActions } = this.props;

    taskActions.submitStudents(task, currentSelection);
    drawerActions.closeDrawerAndRemoveContent();
    revealActions.studentsWithFilesConfirmation(false);
  };

  closeMenu = () => {
    const { drawerActions } = this.props;
    drawerActions.closeDrawerAndRemoveContent();
  };

  render() {
    const { currentSelection } = this.state;
    const { submitConfirmation } = this.props;
    const hideBottomRow = !this.tryIfChangedList();

    if (submitConfirmation) {
      this.submitStudents(currentSelection);
    }

    return (
      <DrawerCommonPanelCustom
        closePanel={this.closeMenu}
        hideRowButtons={hideBottomRow}
        panelHeaderTitle={I18n.t('participants.drawer.students.title')}
        showCancelButton={true}
        handleSecondaryButtonClick={this.closeMenu}
        primaryButtonText={'common.add'}
        secondaryButtonText={'common.back'}
        icon={'left-chevron'}
        onPrimaryButtonClick={this.handlePrimaryButtonClick}
      >
        <MultipleSelectionPanel
          students={this.filterAvaliableStudents()}
          selectStudent={this.handleOnUserClick}
          currentSelection={currentSelection}
        />
        {/*   {!showLoader ? <MultipleSelectionPanel
          students={users}
          selectStudent={this.handleOnUserClick}
          currentSelection={currentSelection}
        /> : <div key={'loader'} className="loader"><CircularProgress/></div>}*/}
      </DrawerCommonPanelCustom>
    );
  }
}

AddUserToTask.propTypes = {
  idClassroom: PropTypes.string,
  idInstitution: PropTypes.number,
  messageAlert: PropTypes.object,
  colors: PropTypes.any,
  selectedClassroomName: PropTypes.string,
  selectedUser: PropTypes.object,
  task: PropTypes.object,
  submitConfirmation: PropTypes.bool,
  drawerActions: PropTypes.object,
  revealActions: PropTypes.object,
  taskActions: PropTypes.object,
  backgroundSecondary: PropTypes.string,
  classroomActions: PropTypes.object,
  allGroups: PropTypes.array
};

function mapDispatchToProps(dispatch) {
  return {
    messageAlert: bindActionCreators(messageAlert, dispatch),
    drawerActions: bindActionCreators(drawerActions, dispatch),
    classroomActions: bindActionCreators(classroomActions, dispatch),
    revealActions: bindActionCreators(revealActions, dispatch),
    taskActions: bindActionCreators(taskActions, dispatch),
    bookActions: bindActionCreators(bookActions, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    task: state.task.selectedTask,
    idClassroom: state.router.params.idClassroom,
    idInstitution: state.school.school.id,
    selectedClassroomName: state.classrooms.selectedClassroom.classroom.name,
    allGroups: state.classrooms.selectedClassroom.groups,
    colors: state.theme.colors,
    submitConfirmation: state.reveal.studentsWithFilesConfirmation,
    backgroundSecondary: state.theme.colors.backgroundSecondary
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddUserToTask);
